module.exports = __webpack_public_path__ + "img/fmcs_zikong.e844742f.png";